// https://awhitepixel.com/blog/wordpress-gutenberg-add-image-select-custom-block/

/**
 * External Dependencies
 */
import classnames from 'classnames'; //npm install classnames --save
import assign from 'lodash.assign'; // https://code.tutsplus.com/tutorials/wordpress-gutenberg-block-api-extending-blocks--cms-31320

/* https://jeffreycarandang.com/extending-gutenberg-core-blocks-with-custom-attributes-and-controls/ */

/**
 * WordPress Dependencies
 */
const { __ } = wp.i18n;
const { addFilter } = wp.hooks;
const { Component, Fragment }	= wp.element;
const { InspectorAdvancedControls, MediaUpload, MediaUploadCheck }	= wp.blockEditor;
//const { InspectorControls, MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { PanelBody, Button, ResponsiveWrapper } = wp.components;
//const { compose } = wp.compose;
const { withSelect } = wp.data;
const { createHigherOrderComponent } = wp.compose;

//restrict to specific block names
const allowedBlocks = [ 'core/columns', 'core/column' ];

/**
 * Add custom attribute for row background images.
 *
 * @param {Object} settings Settings for the block.
 *
 * @return {Object} settings Modified settings.
 */
function addAttributes( settings ) {

	//check if object exists for old Gutenberg version compatibility
	//add allowedBlocks restriction
	if( typeof settings.attributes !== 'undefined' && allowedBlocks.includes( settings.name ) ){

		settings.attributes = Object.assign( settings.attributes, {
			mediaId: {
				type: 'number',
				default: 0
			},
			mediaUrl: {
				type: 'string',
				default: ''
			}
		});

	}

	return settings;
}

/**
 * Add row background image controls on Advanced Block Panel.
 *
 * @param {function} BlockEdit Block edit component.
 *
 * @return {function} BlockEdit Modified block edit component.
 */
const withAdvancedControls = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {

		const {
			name,
			attributes,
			setAttributes,
			isSelected,
		} = props;

		const {
			mediaId,
			mediaUrl,
		} = attributes;

		const removeMedia = () => {
			props.setAttributes({
				mediaId: 0,
				mediaUrl: ''
			});
		}

	 	const onSelectMedia = (media) => {
			props.setAttributes({
				mediaId: media.id,
				mediaUrl: media.url
			});
		}

		const blockStyle = {
			backgroundImage: attributes.mediaUrl != '' ? 'url("' + attributes.mediaUrl + '")' : 'none'
		};

		return (
			<Fragment>
				<BlockEdit {...props} />
				{ isSelected && allowedBlocks.includes( name ) &&
			<InspectorAdvancedControls>
				<PanelBody
					title={__('Background Image', 'awp')}
					initialOpen={ false }
				>
					<div className="editor-post-featured-image">
						<MediaUploadCheck>
							<MediaUpload
								onSelect={onSelectMedia}
								value={attributes.mediaId}
								allowedTypes={ ['image'] }
								render={({open}) => (
									<Button
										className={attributes.mediaId == 0 ? 'editor-post-featured-image__toggle' : 'editor-post-featured-image__preview'}
										onClick={open}
									>
										{attributes.mediaId == 0 && __('Choose an image', 'awp')}
										{(attributes.mediaId != undefined) && (attributes.mediaUrl) &&
						            			<ResponsiveWrapper
									    		//naturalWidth={ props.media.media_details.width }
												//naturalHeight={ props.media.media_details.height }
									    	>
									    		<img src={attributes.mediaUrl} alt={ __( 'Background Image', 'image-selector' ) } />
									    	</ResponsiveWrapper>
						            		}
									</Button>
								)}
							/>
						</MediaUploadCheck>
						{attributes.mediaId != 0 &&
							<MediaUploadCheck>
								<MediaUpload
									title={__('Replace image', 'awp')}
									value={attributes.mediaId}
									onSelect={onSelectMedia}
									allowedTypes={['image']}
									render={({open}) => (
										<Button onClick={open} variant="secondary">{__('Replace image', 'awp')}</Button>
									)}
								/>
							</MediaUploadCheck>
						}
						{attributes.mediaId != 0 &&
							<MediaUploadCheck>
								<Button onClick={removeMedia}  variant="link" isDestructive>{__('Remove image', 'awp')}</Button>
							</MediaUploadCheck>
						}
					</div>
				</PanelBody>
			</InspectorAdvancedControls>
				}

			</Fragment>
		);
	};
}, 'withAdvancedControls');

/* Apply the adjustment in the editor too */  // https://wordpress.stackexchange.com/questions/324091/

/* Currently this is disabled */

const withBackgroundImage = createHigherOrderComponent( ( BlockListBlock ) => {
    return ( props ) => {

	if ( allowedBlocks.includes( props.name )) {
        if (props.attributes.mediaId){

			// https://wordpress.stackexchange.com/questions/377256/ - no way to apply the BG as a styles as yet as far as I can see!
            return <BlockListBlock { ...props } className={classnames( props.className, 'background-image-present' )} />;
            //return <BlockListBlock { ...props } style={{backgroundImage: "url(" + props.attributes.mediaUrl + ")"}}  />;

		} else {
	    	return <BlockListBlock {...props} />
       	}
	} else {
           	return <BlockListBlock {...props} />
    }

    };
}, 'withClientIdClassName' );

wp.hooks.addFilter( 'editor.BlockListBlock', 'pwd-blocks/with-client-id-class-name', withBackgroundImage )


/**
 * Add custom element class in save element.
 *
 * @param {Object} extraProps     Block element.
 * @param {Object} blockType      Blocks object.
 * @param {Object} attributes     Blocks attributes.
 *
 * @return {Object} extraProps Modified block element.
 */
function applyExtraClass( extraProps, blockType, attributes ) {

	const {
		mediaId,
		mediaUrl,
	} = attributes;

	//check if attribute exists for old Gutenberg version compatibility
	//add allowedBlocks restriction
	if ( typeof mediaId !== 'undefined' && mediaId && allowedBlocks.includes( blockType.name ) ) {
		extraProps.className = classnames( extraProps.className, 'background-image-present' );
        assign( extraProps, { style: { 'background-image': extraProps.style ? extraProps.style[ 'background-image' ] : '', 'background-image': 'url(\''+mediaUrl+'\')' } } );
	}

	return extraProps;
}


//add filters

addFilter(
	'blocks.registerBlockType',
	'pwd-blocks/custom-attributes',
	addAttributes
);

addFilter(
	'editor.BlockEdit',
	'pwd-blocks/custom-advanced-control',
	withAdvancedControls
);

addFilter(
	'blocks.getSaveContent.extraProps',
	'pwd-blocks/applyExtraClass',
	applyExtraClass
);

